import { useEffect } from 'react';

export const useInterval = (callback, delay = 1000) => {
  useEffect(() => {
    const id = setInterval(callback, delay);
    return () => clearInterval(id);
  }, [delay, callback]);
};
